import { useBoundStore } from '@/stores/store';

export function useLoading(): {
  isLoading: boolean;
} {
  const { loading } = useBoundStore((state) => state);
  const isLoading = loading.length > 0;

  return { isLoading };
}
